export const Endpoint = () => `/api/v4/bulletin/ai-insight-counter/`;
export const QueryKey = () => ['v4', 'bulletins', 'ai-insight-counter'];
export type Payload = never;
export type Response = {
    limit: number | null;
    count: number;
};
